<template>
    <div>
        <h5>
            {{ label }}
            <v-chip v-if="required" class="ma-2" x-small outlined color="primary">{{$t("form.mandatory")}}</v-chip>
        </h5>
        <v-row>
            <v-col>
                <v-textarea
                    v-model="value"
                    @input="updateValue"
                    :rules="allRules"
                    outlined
                    v-if="!readonly"
                ></v-textarea>
                <v-textarea
                    v-else
                    :value="value"
                    readonly
                    disabled
                ></v-textarea>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        rules: {
            type: Object,
            required: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        updateValue(newValue) {
            console.log("emitting new textarea value");
            this.$emit('input', newValue);
        }
    },
    computed: {
        allRules() {
            let rules = this.rules || [];
            if (this.required) {
            rules = [...rules, v => !!v || this.$t('forms.field.validation.required')];
            }
            return rules;
        }
    }
}
</script>